// @ts-check
import { observer } from 'mobx-react-lite';
import React from 'react';
import { ShippingCountryState } from 'src/scripts/utils/shipping';
import { toLocalCurrencyShowEstimate } from '../../../utils/currency';
import { ReviewsBottomLine } from './Reviews';
import { IProduct } from '../types/PDP';
import { getGCMinMaxPrice } from 'src/scripts/templates/product/utils';

// ? [REVISIT] does `isFinalSale` not need to be used?
let Price = (props: {
  actualPrice: number;
  displayPrice: number;
  isFinalSale: boolean;
  withReviews?: boolean;
  product: IProduct;
  colorwayProductId?: string;
  productHandle?: string;
}) => {
  const { actualPrice, displayPrice, withReviews = true, product, colorwayProductId, productHandle } = props;
  //#region ref: ECOM-1721
  const userPreferredCountry = ShippingCountryState.countryCode;
  const isUserPreferredCountryIsrael = userPreferredCountry && userPreferredCountry === 'IL';
  const showAdditionalGEClass = isUserPreferredCountryIsrael && actualPrice < 75;
  //#endregion

  const gcMinMaxPrice = getGCMinMaxPrice(product);

  return (
    <div className={`price__wrapper ${showAdditionalGEClass ? 'ge_lt_minimum_price' : ''}`}>
      <div className="Price">
        <span
          className={
            actualPrice < displayPrice
              ? 'product__price sale__price large-p semibold d-inline-block d-md-none'
              : 'product__price large-p semibold d-inline-block d-md-none'
          }
          data-currency
        >
          {product?.productType === 'Gift Card' && gcMinMaxPrice?.priceMin && gcMinMaxPrice?.priceMax
            ? `${toLocalCurrencyShowEstimate(gcMinMaxPrice?.priceMin)} - ${toLocalCurrencyShowEstimate(
                gcMinMaxPrice?.priceMax
              )}`
            : toLocalCurrencyShowEstimate(actualPrice)}
        </span>
        {actualPrice < displayPrice && (
          <span className="product__price product__price--sale large-p semibold d-inline-block d-md-none">
            <s>{toLocalCurrencyShowEstimate(displayPrice)}</s>
          </span>
        )}
        <span
          className={
            actualPrice < displayPrice
              ? 'product__price sale__price body-large uppercase d-none d-md-inline-block'
              : 'product__price body-large uppercase d-none d-md-inline-block'
          }
          data-currency
        >
          {product?.productType === 'Gift Card' && gcMinMaxPrice?.priceMin && gcMinMaxPrice?.priceMax
            ? `${toLocalCurrencyShowEstimate(gcMinMaxPrice?.priceMin)} - ${toLocalCurrencyShowEstimate(
                gcMinMaxPrice?.priceMax
              )}`
            : toLocalCurrencyShowEstimate(actualPrice)}
        </span>
        {actualPrice < displayPrice && (
          <span className="product__price product__price--sale h6 uppercase d-none d-md-inline-block">
            <s>{toLocalCurrencyShowEstimate(displayPrice)}</s>
          </span>
        )}
      </div>
      {withReviews && <ReviewsBottomLine colorwayProductId={colorwayProductId} productHandle={productHandle} />}
    </div>
  );
};
Price = observer(Price);

export default Price;
